<div class="accountPage">
  <h3>Account</h3>
  <div class="row accountPageTopFilter">
    <div class="col-md-10 col-lg-11 landscape">
      <app-efulfillmentfilter [filters]="filterArray" (SearchFilter)="filterGrid($event)" [IsAccountTab]='true'></app-efulfillmentfilter>
    </div>
    <div class="col-md-2 col-lg-1 export-btn-outer text-center md-pl-0 d-none d-sm-none d-md-block sm-hide">
      <div class="export-btn">
        <button data-testid="ddl-account-export" mat-raised-button class="btns xs-mt-0 md-mt-10" color="primary" (click)="onExportBtnClick($event)">Export</button>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 mobile-pad-0">
      <app-efulfillmenttable [propHeaderDS]="headerList" [propBodyDS]="dataSourceList" (RowChecked)="TableRowChecked($event)"
                             [propExport]="export" (AllRowChecked)="AllRowChecked($event)"></app-efulfillmenttable>
    </div>
    <div class="col-md-12 padding-t20 text-right account-footer">
      <button data-testid="ddl-select-account" mat-raised-button class="btns margin-r15 xs-mb-5 md-mb-0 xs-button" color="primary" *ngIf="addToAccountVisible" (click)="saveAddToAccount($event, true)">Select Account</button>
      <button data-testid="ddl-add-account" mat-raised-button class="btns xs-button" color="primary" *ngIf="addToAccountVisible" (click)="saveAddToAccount($event, false)">Add Account</button>
    </div>
  </div>
</div>
